// Map HTTP status codes to i18n translation keys
const AI_CHAT_ERROR_STATUS_KEYS: Record<number, string> = {
    429: 'ai-chat.error.rate-limited',
    400: 'ai-chat.error.bad-request',
    408: 'ai-chat.error.timeout',
    500: 'ai-chat.error.server-error',
};

const DEFAULT_ERROR_KEY = 'ai-chat.error.server-error';

export const AI_MONTHLY_USAGE_LIMIT_EXCEEDED_CODE = 'AI_MONTHLY_USAGE_LIMIT_EXCEEDED';
const AI_MONTHLY_USAGE_LIMIT_EXCEEDED_KEY = 'ai-chat.error.monthly-usage-limit-exceeded';

export const getErrorMessageKey = (httpStatus?: number): string => {
    if (!httpStatus) return DEFAULT_ERROR_KEY;
    return AI_CHAT_ERROR_STATUS_KEYS[httpStatus] || DEFAULT_ERROR_KEY;
};

/**
 * The line for a refused send, read off the error body the backend answered with: its code where one has its own
 * line, else its HTTP status. Null when the body is no such answer, as when the request got no response at all.
 */
export const getErrorMessageKeyFromBody = (body: string): string | null => {
    try {
        const parsed: unknown = JSON.parse(body);
        if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return null;

        const { code, status } = parsed as Record<string, unknown>;
        if (code === AI_MONTHLY_USAGE_LIMIT_EXCEEDED_CODE) return AI_MONTHLY_USAGE_LIMIT_EXCEEDED_KEY;
        return typeof status === 'number' ? getErrorMessageKey(status) : null;
    } catch {
        return null;
    }
};
